import { PawPrint, BadgeCheck, ArrowUp } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const cities = [
  "Kraków", "Legnica", "Żagań", "Kielce",
  "Piotrków Tryb.", "Stargard", "Chełm", "Milanówek",
  "Rzezawa", "Hajnówka", "Sokółka", "Szumowo",
];

export const InstagramStory12Minimal = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#FFFFFF",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          opacity: 0.15,
        }}
      />

      {/* Clean white overlay for minimalist look */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(180deg, rgba(255,255,255,0.97) 0%, rgba(250,252,250,0.95) 100%)",
          zIndex: 1,
        }}
      />

      {/* Safe zone content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 100px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Massive centered number - hero element */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Small label above number */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "16px",
            }}
          >
            <BadgeCheck style={{ width: "32px", height: "32px", color: "#4E8A6E" }} />
            <span style={{ fontSize: "28px", fontWeight: 600, color: "#6B8A7A", letterSpacing: "4px", textTransform: "uppercase" }}>
              Zweryfikowane
            </span>
          </div>

          {/* Giant number */}
          <div
            style={{
              fontSize: "320px",
              fontWeight: 800,
              color: "#2D5A3D",
              lineHeight: 0.85,
              marginBottom: "24px",
            }}
          >
            12
          </div>

          {/* Subtitle */}
          <span style={{ fontSize: "42px", fontWeight: 700, color: "#4E8A6E", marginBottom: "48px" }}>
            schronisk 🎉
          </span>

          {/* Cities as simple text list */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "8px 24px",
              maxWidth: "800px",
            }}
          >
            {cities.map((city, i) => (
              <span
                key={i}
                style={{
                  fontSize: "26px",
                  fontWeight: 600,
                  color: "#6B8A7A",
                }}
              >
                {city}{i < cities.length - 1 ? " •" : ""}
              </span>
            ))}
          </div>
        </div>

        {/* Bottom CTA - minimalist */}
        <div style={{ textAlign: "center" }}>
          <ArrowUp style={{ width: "40px", height: "40px", color: "#4E8A6E", marginBottom: "12px" }} />
          <p style={{ fontSize: "28px", fontWeight: 600, color: "#4E8A6E", margin: "0 0 28px" }}>
            Sprawdź ich potrzeby
          </p>

          {/* Minimal logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "12px",
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "24px", height: "24px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "26px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
